(function () {
  'use strict';
  // Delegation supports theme editor reloads and AJAX collection replacements.
  if (window.pfhCategoryRailTracking) return;
  window.pfhCategoryRailTracking = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-rail-collection]');
    var rail = link && link.closest('[data-category-rail]');
    if (!rail || typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', 'category_rail_click', {
        source_collection: rail.dataset.sourceCollection,
        rail_collection: link.dataset.railCollection,
        rail_position: Number(link.dataset.railPosition),
        transport_type: 'beacon'
      });
    } catch (error) {
      // Analytics must never interrupt collection navigation.
    }
  });
})();

/* Click and drag to scroll the rail with a mouse (desktop). Touch keeps native swipe. */
(function () {
  document.querySelectorAll('.pfh-category-rail__track').forEach(function (track) {
    if (track.dataset.dragReady) return;
    track.dataset.dragReady = '1';
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; track.classList.remove('is-dragging'); track.style.scrollSnapType = '';
    });
    // A drag should not open the tile under the mouse.
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
})();
